import { XBoldIcon } from '@/icons';
import { showImageUploadModal } from '@/shared/features/image-upload/components';
import { imageDetailModal } from '@/shared/modals/ImageDetailModal';
import { cn } from '@/utils';
import { useImageUploadInput } from '@/views/build/hook/useImageUploadInput';
import { useEditMode } from '../../../focus/useIsEditMode';
import { useDroppableImageUploadInput } from '../../hook/useDroppableImageUploadInput';
import { QuizImage } from '../../QuizImage';
import { HintImageUploadButton } from './HintImageUploadButton';
export const ImageHintInput = ({
  onChange,
  value
}: {
  onChange: (imageUrl: string) => void;
  value?: string;
}) => {
  const {
    isEditMode
  } = useEditMode();
  const {
    isUploading,
    accept,
    handleFileChange
  } = useImageUploadInput({
    onUploadComplete: imageUrl => {
      onChange(imageUrl);
    }
  });
  const {
    rootProps,
    inputProps,
    isDragActive,
    inputRef
  } = useDroppableImageUploadInput({
    onFileChange: (file: File | null) => {
      if (file) void handleFileChange(file);
    },
    accept,
    imageUrl: value
  });
  if (isUploading) {
    return <div className="size-[120px]">
        <QuizImage.Loading />
      </div>;
  }
  return <div className={cn('w-fit rounded-xs', (!value || isUploading) && 'outline outline-[1px] outline-gray-200', isDragActive && 'outline outline-2 outline-[#A49BFF]')} tabIndex={0} onFocus={e => {
    e.stopPropagation();
  }} data-sentry-component="ImageHintInput" data-sentry-source-file="ImageHintInput.tsx">
      <input {...inputProps} ref={inputRef} type="file" className="hidden" accept={accept} />
      {value ? <div className="relative">
          <QuizImage.Container className="size-[62px]" onClick={() => {
        imageDetailModal.open(value);
      }}>
            <QuizImage.Thumbnail src={value} alt="hint" />
          </QuizImage.Container>

          {isEditMode && <QuizImage.RemoveButton className="-right-xs -top-xs cursor-pointer shadow-xs" onClick={() => onChange('')}>
              <XBoldIcon width={14} height={14} className="[&>*]:fill-white" />
            </QuizImage.RemoveButton>}
        </div> : <HintImageUploadButton {...rootProps} className="size-[120px]" onClick={() => {
      showImageUploadModal({
        onUploadStart: (file: File | null) => {
          void handleFileChange(file);
        },
        place: 'build',
        imageUrl: value
      });
    }} />}
    </div>;
};